import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../context/I18nContext";
import Logo from "../components/Logo";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Register() {
  const { t } = useI18n();
  const { register, loginWithGoogle } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const onChange = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await register(form);
      nav("/dashboard");
    } catch (e2) {
      setErr(formatApiErrorDetail(e2?.response?.data?.detail) || e2.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[78vh] flex items-center justify-center px-6 py-16" style={{ background: "var(--gai-white)" }} data-testid="page-register">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Logo size={64} /></div>
        <div className="text-center">
          <div className="text-[0.66rem] font-bold tracking-[0.24em] uppercase mb-3" style={{ color: "var(--gai-red)" }}>Inscription</div>
          <h1 className="serif text-4xl" style={{ color: "var(--gai-black)", fontFamily: "'Playfair Display', serif" }}>{t("auth.registerTitle")}</h1>
          <p className="mt-3" style={{ color: "var(--gai-grey-600)" }}>{t("auth.registerSub")}</p>
        </div>

        <form onSubmit={submit} className="mt-10 space-y-5" data-testid="register-form">
          <div>
            <label className="gai-label">{t("auth.name")}</label>
            <input required value={form.name} onChange={onChange("name")} className="gai-input" data-testid="register-name" />
          </div>
          <div>
            <label className="gai-label">{t("auth.email")}</label>
            <input required type="email" value={form.email} onChange={onChange("email")} className="gai-input" data-testid="register-email" />
          </div>
          <div>
            <label className="gai-label">{t("auth.password")}</label>
            <input required type="password" minLength={6} value={form.password} onChange={onChange("password")} className="gai-input" data-testid="register-password" />
          </div>
          {err && <div className="text-sm p-3" style={{ background: "var(--gai-red-soft)", color: "var(--gai-red-ink)", border: "1px solid var(--gai-red)" }} data-testid="register-error">{err}</div>}
          <button disabled={loading} className="gai-btn-gold w-full justify-center" data-testid="register-submit">
            {loading ? t("common.sending") : t("auth.register")}
          </button>
        </form>

        <div className="my-8 flex items-center gap-4 text-[0.68rem] tracking-[0.22em] uppercase" style={{ color: "var(--gai-grey-500)" }}>
          <span className="flex-1 h-px" style={{ background: "var(--gai-grey-200)" }} />
          <span>Ou</span>
          <span className="flex-1 h-px" style={{ background: "var(--gai-grey-200)" }} />
        </div>

        <button onClick={loginWithGoogle} className="gai-btn-outline w-full justify-center" data-testid="register-google">
          {t("auth.google")}
        </button>

        <p className="mt-10 text-center text-sm" style={{ color: "var(--gai-grey-600)" }}>
          {t("auth.hasAccount")} <Link to="/connexion" className="font-semibold" style={{ color: "var(--gai-red)" }} data-testid="register-login-link">{t("auth.signIn")}</Link>
        </p>
      </div>
    </div>
  );
}
